import React from "react";

const Footer = () => {
  return (
    <footer className="py-10 text-center text-gray-400 border-t border-gray-800">
      <div className="container mx-auto px-6">
        <p>&copy; 2024 TestOmega. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
